import type { ReactNode } from "react";

import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";

/** A blog page in the platform's chrome: the head card with whatever opens the page, then the content. */
export const BlogPage = ({ hero, children }: { hero?: ReactNode; children: ReactNode }) => (
  <PlatformPage head={<PlatformHead>{hero}</PlatformHead>}>{children}</PlatformPage>
);
